import * as cookies from 'cookie';

export const COOKIE_NAME = 'IDENTIFICATION_NEEDED';
export const COOKIE_DOMAIN = '.cian.ru';
export const COOKIE_OPTIONS = {
  secure: true,
  path: '/',
  domain: COOKIE_DOMAIN,
  maxAge: 60 * 60, // в секундах
};

export const setIdentificationCookies = () => {
  const currentCookies = document.cookie;
  const hasCookie = currentCookies.indexOf(COOKIE_NAME) !== -1;

  if (hasCookie) {
    return;
  }

  document.cookie = cookies.serialize(COOKIE_NAME, '1', COOKIE_OPTIONS);
};
